import request from '../utils/request'

// 箭头函数
// export const userLogin = params => request('post','/user/userLogin',params)
// export const userLogin=function(params){
//     return request('post','/user/userLogin',params)
// }

export function now(){
    return request({
        method: 'get',
        url: '/qWeather/now',
    })
}
export function weatherForecasts(){
    return request({
        method: 'get',
        url: '/qWeather/weatherForecasts',
    })
}
export function indices(){
    return request({
        method: 'get',
        url: '/qWeather/indices',
    })
}